import React, { useState } from 'react';
import styles from "../../Configurations.module.css";
import ClientTypes from './client-types/ClientTypes';
import ContactTypes from './contact-types/ContactTypes';

const ClientSettings = () => {
    const [activeTab, setActiveTab] = useState('types');

    const tabs = [
        { id: 'types', label: 'Client Types', component: ClientTypes },
        { id: 'contact-types', label: 'Contact Types', component: ContactTypes }
    ];

    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || ClientTypes;

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <h2>Client Settings</h2>
                <p>Manage client-specific configurations and note types across different modules.</p>
            </div>

            <div className={styles.tabContainer}>
                <div className={styles.tabNav}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className={styles.tabContent}>
                    <ActiveComponent />
                </div>
            </div>
        </div>
    );
};

export default ClientSettings;
